<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-border ts-border-blue-400 ts-p-4 ts-rounded-lg ts-relative">
        <label
          class="ts-absolute ts-top-0 ts--mt-3 ts-z-50 ts-bg-white ts-px-3 ts-pr-5 required"
        >{{ $t('dealerUser.dealerType') }}</label>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group ts-flex ts-space-x-5">
              <ts-radio 
                v-model="model.dealer_type" 
                name="dealer_type" 
                value="super" class="ts-text-xs"
                @input="onDealerTypeChange"
              >{{$t('dealerUser.superDealer')}}</ts-radio>
              <ts-radio 
                v-model="model.dealer_type" 
                name="dealer_type" 
                value="normal" class="ts-text-xs"
                @input="onDealerTypeChange"
              >{{$t('dealerUser.dealer')}}</ts-radio>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-select 
                class="ts-w-full"
                show-search
                v-model="model.dealer_id"
                :allowClear="true"
                :placeholder="$t('dealerUser.searchDealerName')"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="fetching ? undefined : null"
                @search="fetchDealer"
              >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="(d, index) in dealers" :key="index" :value="d.dealer_id">
                  {{ d.dealer_name }}
                </a-select-option>
              </a-select>
              <div class="validate ts-text-xs" v-if="errors.has('dealer_id')" >
                {{ errors.first('dealer_id') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ts-mt-3 ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('dealerUser.diplayName') }}</label>
            <input type="text" class="form-control" v-model.trim="model.name" />
            <div class="validate ts-text-xs" v-if="errors.has('name')" >
              {{ errors.first('name') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('dealerUser.userName') }}</label>
            <input type="text" class="form-control" v-model.trim="model.username" />
            <div class="validate ts-text-xs" v-if="errors.has('username')" >
              {{ errors.first('username') }}
            </div>            
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('dealerUser.password') }}</label>
            <input type="password" class="form-control" v-model.trim="model.password" />
            <div class="validate ts-text-xs" v-if="errors.has('password')" >
              {{ errors.first('password') }}
            </div>      
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('dealerUser.confirm') }}</label>
            <input type="password" class="form-control" v-model.trim="model.password_confirmation" />
            <div class="validate ts-text-xs" v-if="errors.has('password_confirmation')" >
              {{ errors.first('password_confirmation') }}
            </div> 
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-space-x-3 ts-text-right ts-mt-3">
            <ts-button @click.prevent="$emit('close')" >{{ $t('cancel') }}</ts-button>
            <ts-button 
              color="primary" 
              outline
              :waiting="waiting_new"
              @click.prevent="onSaveNew"
            >{{ $t('save_add_new') }}</ts-button>
            <ts-button 
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
            >{{ $t('save') }}</ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'gameSetFormCreateUpdate',
  data() {
    return {
      loading: false,
      fetching: false,
      waiting_new: false,
      waiting: false,
      updating: false,
      errors: new Errors(),
      dealers: [], 
      model: {
        dealer_type: 'super',
        user_id: 0,
        username: null,
        dealer_id: undefined,
        name: null,
        password: null,
        password_confirmation: null
      }
    }
  },
  methods: {
    ...mapActions('administrator/dealerUser', ['store', 'getDealer']),
    fetchDealer: _.debounce(function(value){
      if(!value){
        this.dealers = []
        return 
      }
      this.fetching = true
      this.getDealer({
        search: value,
        fields: {
          dealer_profiles: 'dealer_id,dealer_name'
        },
        filter: {
          dealer_type_id: this.model.dealer_type == 'super' ? 1 : 2
        },
        page: -1
      })
      .then(response => {
        this.dealers = response.data
      })
      .catch(error => {
        this.$toasted.error(error.message)
      })
      .finally(() => {
        this.fetching = false
      })
    }, 500),
    onDealerTypeChange(){
      this.model.dealer_id = null
      this.dealers = []
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.user_id = 0
      this.model.username = null
      this.model.dealer_id = null
      this.model.name = null
      this.model.password = null
      this.model.password_confirmation = null
    }
  }
}
</script>
